;(function($) {
    'use strict';
    $(document).ready(function() {
        $('form[data-validate]').each(function() {
            $(this).on('blur', 'input[data-validate], select[data-validate], textarea[data-validate]', function() {
                $(this).closest('form').validated({fields: this});
            });
            $(this).on('click', 'input[type=checkbox], input[type=radio]', function(event) {
                var $input = $(this);
                var $siblings = $input.closest('form').find('input[name=' + $input.attr('name') + ']');
                $siblings.closest('label').removeClass('selected');
                $siblings.filter(':checked').each(function() {
                    $(this).closest('label').addClass('selected');
                });
            });
            $(this).on('click', 'button[data-validate]', function(event) {
                event.preventDefault();
                var target = $(this).data('tab');
                var step = $(this).data('step');
                var $tabs = $('.tab');
                var $steps = $('.step');
                var switchTab = function(target) {
                    $tabs.hide().removeClass('active');
                    $steps.removeClass('active');
                    $steps.removeClass('completed');
                    for (var i = 0; i < $steps.length; ++i) {
                        if ($($steps[i]).hasClass(target)) {
                            break;
                        }
                        $($steps[i]).addClass('completed');
                    }
                    $('.step.' + target).addClass('active').show();
                    $('.tab.' + target).addClass('active').show();
                }
                var $form = $(this).closest('form');
                var $tab = $(this).closest('.tab');
                $form.validated({fields: $tab.find('[data-validate]'), data: {step: step}, files: true, submit: true}, function(validated, response) {
                    if (response.message) {
                        if (response.success) {
                            $form.empty().append( 
                                $('<div class="feedback success">').html(response.message)
                            );
                        } else {
                            $form.empty().append( 
                                $('<div class="feedback error">').html(response.message)
                            );
                        }
                    }
                    if (response.redirect) {
                        setTimeout(function() {
                            window.location.href = response.redirect;
                        }, 1500);
                    }
                    validated && target && switchTab(target);
                });
            });
        });
    });
})(jQuery);